import { DelegatedObservableArrayChangeListenner, ObservableArray, ObservableArrayChangeListenner, View, ViewModel } from "binder";
import { getAsBoolean } from "../../utilities";
import  { LineItemView } from "./lineItem-view"

export class LineItemViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.isOpen = false;
        this.hasChild = false;
        this.internalItems = ObservableArray.create<LineItemViewModel>();
        this.openall = false;
        this.items = ObservableArray.create<ViewModel>();
        this.itemsMap = new WeakMap<ViewModel,LineItemViewModel>();
        this.isOpen = false;
        this.isFiltered = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new LineItemView();
    }
    public getTypeId(): string {
        return "VM-71F1A92D-26A1-4DCC-964A-CAE2BD2FEC11"
    }
    public set template(v: Node) { this._template = v; this.updateItems(); } public get template(): Node { return this._template;} private _template: Node;
    public set childPath(v: string) { this._childPath = v; this.updateItems();} public get childPath(): string { return this._childPath;} private _childPath: string;
    public set element(v: ViewModel) { this._element = v; } public get element(): ViewModel { return this._element;} private _element: ViewModel;
    public set openall(v: boolean) { 
        this._openAll = getAsBoolean(v); 
        if(this.openall==true)
            this.internalItems.forEach(x=>{
                x.openall=true;
            });
            this.isOpen = true;
    } public get openall(): boolean { return this._openAll;} private _openAll: boolean;
    
    updateItems(){
        if(this.childPath && this.element){
            this.items = this.element[this.childPath];
        }
    }
    private changeListenner : ObservableArrayChangeListenner;
    public set items(v: ObservableArray<ViewModel>) { 
        if(this.items!=null){
            this.items.removeChangeListenner(this.changeListenner);
        }
        this._items = v; 
        if(this.items!=null){
            let listenner = new DelegatedObservableArrayChangeListenner(this,arr=>this.listChanged());
            this.items.addChangeListenner(listenner);
            this.listChanged();
        }
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    
    public set internalItems(v: ObservableArray<LineItemViewModel>) { this._internalItems = v; this.listChanged } public get internalItems(): ObservableArray<LineItemViewModel> { return this._internalItems;} private _internalItems: ObservableArray<LineItemViewModel>;
    private itemsMap:WeakMap<ViewModel,LineItemViewModel>;
    public set hasChild(v: boolean) { this._hasChild = v; } public get hasChild(): boolean { return this._hasChild;} private _hasChild: boolean;
    public set isOpen(v: boolean) { this._isOpen = v; } public get isOpen(): boolean { return this._isOpen;} private _isOpen: boolean;
    public set isFiltered(v: boolean) { this._isFiltered = v; } public get isFiltered(): boolean { return this._isFiltered;} private _isFiltered: boolean;
    public set parentLineItem(v: LineItemViewModel) { this._parentLineItem = v; } public get parentLineItem(): LineItemViewModel { return this._parentLineItem;} private _parentLineItem: LineItemViewModel;
    
    listChanged(){
        if(this.childPath && this.internalItems && this.items)
            this.internalItems.update(...this.items.map(x=>{
                if(this.itemsMap.has(x)==false){
                    let newContainer = new LineItemViewModel(this);
                    newContainer.parentLineItem = this;
                    newContainer.template = this.template;
                    newContainer.element = x;
                    newContainer.childPath = this.childPath;
                    newContainer.openall = this.openall;
                    newContainer.isOpen = this.openall;

                    this.itemsMap.set(x,newContainer);
                }
                return this.itemsMap.get(x);
            }));
        this.hasChild = this.internalItems.length>0;
        if(this.hasChild==false)
            this.isOpen=false;
    }   
}
